export default {
    methods: {
        formatCurrency: function (amount) {
            if (typeof amount !== 'undefined') {
                return Number(amount).toLocaleString('nl-NL', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            }
            return amount;
        },
        formatCurrencyToNumber: function (currencyValue) {
            return Number(
                (currencyValue + '')
                    .replace(/\./gi, '')
                    .replace(',', '.')
                    .replace(/,/gi, '')
            );
        },
        calculateToPersonalAmount: function (amount) {
            if (typeof amount !== 'undefined') {
                return (Number(amount) / 100) * 70;
            }
            return amount;
        }
    }
};
